export enum AppsEnum {
  Giphy = 'giphy',
}
